import React from 'react';
import PropTypes from 'prop-types';
import CategoryItem2 from './CategoryItem2';

import { target } from 'react-aim';

@target()
export default class CategoryItem2List extends React.Component {
  static propTypes = {
    productCategory: PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayCategoryId: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      disableMarketplaceBanner: PropTypes.bool,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          displayCategoryId: PropTypes.number.isRequired,
          itemCount: PropTypes.number.isRequired
        })
      ).isRequired
    })
  };

  render() {
    let { name, displayCategoryId, children } = this.props.productCategory;

    let catId = '' + displayCategoryId;
    if (catId.length == 1) {
      catId = '0' + catId;
    }

    let className = `categorySecondLayer cat${catId}`;

    let rows = children.map((productCategory, index) => {
      return (
        <CategoryItem2 key={index}
          parentDisplayCategoryId={displayCategoryId}
          productCategory={productCategory}
          disableMarketplaceBanner={this.props.disableMarketplaceBanner}
        />
      );
    });

    return (
      <div className={className}>
        <p className="name">{name}</p>
        {rows}
      </div>
    );
  }
}
